import AuthLayout from './auth-layout';

export default AuthLayout;
